export const ADD_TAG = "ADD_TAG"
export const ADD_TAG_SUCCESS = "ADD_TAG_SUCCESS"
export const ADD_TAG_ERROR = "ADD_TAG_ERROR"
